import { useDispatch, useSelector } from 'react-redux';

/**
 * Typed version of the `useDispatch` hook.
 * Use throughout your app instead of plain `useDispatch`.
 *
 * @returns {import('@reduxjs/toolkit').ThunkDispatch<any, undefined, any>} The dispatch function
 */
export const useAppDispatch = () => useDispatch();

/**
 * Typed version of the `useSelector` hook.
 * Use throughout your app instead of plain `useSelector`.
 *
 * @template TSelected Result type of the selector function
 * @param {Function} selector Function that accepts the Redux store state and returns a value
 * @returns {TSelected} The selected state
 */
export const useAppSelector = useSelector;
